<template>
  	<el-form class="jc-form cps-create-form advanced-form"
	   	ref="advanced"
	   	:model="advancedForm"
	   	:label-width=labelWidth
	   	:rules="advancedRules">
		<el-form-item :label="$t('create.text.customData') | withColon">
		  	<el-switch v-model="setCustomDataState"
				@change="statueChange"
				on-text=""
				off-text="">
			</el-switch>
		 	<el-tooltip class="ml10" effect="dark" placement="right">
				<div slot="content" class="my-os-disk-tip">
				  {{$t('create.tooltip.customData')}}
				</div>
				<a><i class="jc-icon-my-help"></i></a>
		  	</el-tooltip>
		</el-form-item>
		<el-form-item v-if="setCustomDataState">
			<el-radio-group v-model="selectedUploadMethod" @change="changeUploadMethod">
				<el-radio-button v-for="(uploadMethod,index) in uploadMethods"
					:key="index" :label="uploadMethod.value">
					{{uploadMethod.label}}
				</el-radio-button>
			</el-radio-group>
		</el-form-item>
		<el-form-item v-if="setCustomDataState" class="choose-base64">
			<input type="checkbox" v-model="isBase64" @change="chooseBase64"/><span class="ml5">{{ $t('create.text.hasBase64') }}</span>
		</el-form-item>
		<section v-if="setCustomDataState && selectedUploadMethod ==='uploadText' " class="customData-form">
			<el-form-item  prop="codeVal">
				<el-input type="textarea"
					:autosize="{ minRows: 4, maxRows: 8}"
					v-model.trim="advancedForm.codeVal"
					class="code-textarea"
					@blur="getDataSize"
					:placeholder="(selectedOS ==='Windows' || selectedOS ==='WindowsPC') ? $t('create.placeholder.windowsCodeExample') : $t('create.placeholder.codeExample')">
				</el-input>
			</el-form-item>
			<el-form-item class="code-value-tip">
				<p class="set-data-item-help" v-if="(selectedOS ==='Windows' || selectedOS ==='WindowsPC')">{{$t('create.placeholder.windowsTips')}}</p>
				<p class="set-data-item-help" v-else>{{$t('create.placeholder.customData')}}</p>
			</el-form-item>
		</section>
		<section v-if="setCustomDataState && selectedUploadMethod ==='uploadFile'">
			<el-form-item  prop="codeVal">
				<el-upload
				  class="upload"
				  action="/cps_api/api/cps/parseFile"
				  name="userDataFile"
				  :data="params"
				  :on-change="handleChange"
				  :on-error="handleUploadErr"
				  :on-success="handleUploadSuccess"
				  :on-remove="handleUploadRemove"
				  :file-list="fileList">
				  <el-button size="small" type="primary">{{$t('create.text.chooseFile')}}</el-button>
				  <div slot="tip" class="jc-upload__tip" v-show="!fileList.length">{{$t('create.tooltip.hasNoFile')}}</div>
				</el-upload>
			</el-form-item>
		</section>
  </el-form>
</template>

<script>

import {
  byteCounter, originMaxSize, encodeMaxSize, base64encode, checkIsBase64OrNot, base64decode
} from '@/common/byteCounter';
import {
	UploadFileErrorConstant
} from '@/common/Constants';
export default {
  	name: 'CustomData',
  	props: {
		setCustomData: {
			type: Boolean,
			default: false
		},
		labelWidth: {
			type: String,
			default: '130px'
		},
		region: {
			type: String,
			default: ''
		},
		selectedOS: {
			typer: String,
			default: ''
		}
  	},
  	data() {
		/**
		 * 校验所填内容
		 * 并且在校验通过后将base64(value)传给父组件
		 * @param rule
		 * @param value
		 * @param callback
		 */
		const validateFirstLineCode = (rule, value, callback) => {
		  	if (value === '') {
				callback();
		  	} else if (!checkIsBase64OrNot(value)) {
				const valueArray = value.split('\n');
				if (this.isBase64) {
				  	callback(new Error(this.$t('customScript.noBase64')));
				} else if(this.selectedOS !=='Windows' && this.selectedOS !=='WindowsPC') {
					if (!(valueArray[0].trim() === '#!/bin/bash' || valueArray[0].trim() === '#!/usr/bin/env python')) {
						callback(new Error(this.$t('customScript.firstLine')));
					} else if (byteCounter(value) > originMaxSize) {
						callback(new Error(this.$t('customScript.originMax')));
					} else {
						this.$emit('getCustomData', base64encode(value));
						callback();
					}
				} else {
					if (!(valueArray[0].trim() === 'rem cmd' || valueArray[0].trim() === '<powershell>')) {
						callback(new Error(this.$t('customScript.windowsFirstLine')));
					} else if (byteCounter(value) > originMaxSize) {
						callback(new Error(this.$t('customScript.originMax')));
					} else {
						this.$emit('getCustomData', base64encode(value));
						callback();
					}
				}
		  	} else if (checkIsBase64OrNot(value)) {
				const valueArray = base64decode(value).split('\n');
				if (!this.isBase64) {
					callback(new Error(this.$t('customScript.hasBase64')));
				} else if (this.selectedOS !=='Windows' && this.selectedOS !=='WindowsPC') {
					if (!(valueArray[0].trim() === '#!/bin/bash' || valueArray[0].trim() === '#!/usr/bin/env python')) {
						callback(new Error(this.$t('customScript.firstLine')));
					} else if (byteCounter(base64decode(value)) > originMaxSize) {
						callback(new Error(this.$t('customScript.encodeMax')));
					} else {
					  	this.$emit('getCustomData', value);
					  	callback();
					}
				} else {
					if (!(valueArray[0].trim() === 'rem cmd' || valueArray[0].trim() === '<powershell>')) {
						callback(new Error(this.$t('customScript.windowsFirstLine')));
					} else if (byteCounter(value) > originMaxSize) {
						callback(new Error(this.$t('customScript.originMax')));
					} else {
						this.$emit('getCustomData', value);
						callback();
					}
				}
		  	}
		};
		return {
			// 上传方式
			uploadMethods: [
				{
					value: 'uploadText',
					label: this.$t('create.text.uploadText')
				},{
					value: 'uploadFile',
					label: this.$t('create.text.uploadFile')
				},
			],
			// 默认上传方式
			selectedUploadMethod: 'uploadText',
			// 校验规则
			advancedRules: {
				codeVal: [
					{ validator: validateFirstLineCode, trigger: 'blur' }
				]
			},
			// 自定义数据状态
			setCustomDataState: this.setCustomData,
			// 是否base64编码
			isBase64: false,
			advancedForm: {
				// 输入的值
				codeVal: ''
			},
			params: {
			},
			// 文件列表
			fileList: [],
		};
  	},
    computed: {
		getRealState: {
			get () {
				return this.setCustomData;
			},
			set(newVal) {
				this.setCustomData = newVal;
			}
		}
  	},
	methods: {
		getDataSize() {
			if (this.isBase64) {
				try {
					console.log(base64decode(this.advancedForm.codeVal), '---decodeval---');
				} catch (e) {
				 	console.log(e, this.advancedForm.codeVal);
				}
			} else if (!this.isBase64) {
				console.log(base64encode(this.advancedForm.codeVal), '---encodeval---');
			}
		},
		/**
		 * 自定义数据状态改变时
		 * 清空已填内容
		 * 同时更新父组件绑定的属性值
		 * @param state
		 */
		statueChange(state) {
			if (!state) {
				this.isBase64 = false;
				this.advancedForm.codeVal = '';
			}
		  	this.setParams();
		  	this.$emit('update:setCustomData', this.setCustomDataState);
		},
		/**
		 * 改变采用base64编码选中状态时
		 * 还要同时触发内容校验
		 */
		chooseBase64() {
			this.setParams();
			this.$refs.advanced.validateField('codeVal');
		},

		handleChange(file, fileList) {
        	this.fileList = fileList.slice(-1);
      	},

      	setParams() {
      		let params = {
      			'region': this.region,
				'base64': this.isBase64
      		}
      		this.params = params;
      	},

      	handleUploadErr(err, file, fileList) {
      		this.isBase64 = false;
      		const message = err.message && err.message.split('400')[1];
      		const errMsg = JSON.parse(message);
      		if (errMsg.errno === UploadFileErrorConstant.uploadFileFormatError) {
      			this.$message.error(this.$t('create.error.uploadFileFormatError'));
      		} else if (errMsg.errno === UploadFileErrorConstant.uploadFileSizeError) {
      			this.$message.error(this.$t('create.error.uploadFileSizeError'));
      		} else if (errMsg.errno === UploadFileErrorConstant.uploadFileBase64) {
      			this.$message.error(this.$t('create.error.uploadFileBase64'));
      		} else if (errMsg.errno === UploadFileErrorConstant.uploadFileNotBase64) {
      			this.$message.error(this.$t('create.error.uploadFileNotBase64'));
      		}
      	},

      	handleUploadSuccess(response, file, fileList) {
      		let fileContent = response.data;
      		this.advancedForm.codeVal = fileContent;
      		//this.isBase64 = true;
      	},

      	handleUploadRemove(file, fileList) {
      		this.advancedForm.codeVal = '';
      		this.isBase64 = false;
      		this.fileList = [];
      	},

      	changeUploadMethod(label) {
			this.isBase64 = false;
			this.advancedForm.codeVal = '';
			this.fileList = [];
			this.setParams();
			this.$refs.advanced.resetFields();
      	}
	},

};
</script>
<style lang="scss">
.customData-form {
  .el-form-item__error {
    width: max-content !important;
  }
}
</style>

<style scoped lang="scss">
  	.advanced-form {
		.code-textarea {
		  width: 500px;
		}
		.code-value-tip {
		  margin-top: -20px;
		}
		.choose-base64 {
		  margin-bottom: 10px;
		}
		.set-data-item-help {
		  line-height: 16px;
		  padding-top: 3px;
		  font-size: 12px;
		  margin: 0;
		  color: #9e9e9e;
		  margin-top: 8px;
		}
		.upload {
			width: 300px;
			.jc-upload__tip {
				display: inline-block;
				margin-left: 10px;
				vertical-align: bottom;
			}
		}
  	}

</style>



// WEBPACK FOOTER //
// src/components/common/customData/CustomData.vue